








import {
  defineComponent,
  computed
} from '@nuxtjs/composition-api';
import { ProductStockStatus } from  '@wemade-vsf/magento-api';

export default defineComponent({
  name: 'ProductStock',
  props: {
    stockStatus: {
      type: String,
      default: ProductStockStatus.InStock
    },
    qty: {
      type: Number,
      default: 0
    }
  },
  setup (props) {
    const isInStock = computed(() => props.stockStatus === ProductStockStatus.InStock && props.qty > 0)

    return {
      isInStock
    }
  }
})
